# Used by credit
# The credit process is based on an old architecture and creates a lead only after the 4th step has been completed.
# This last step is also the one that contains the contact informations (and thus the minimum data).
# This behaviour handles the fake steps, represented by panels and creates the illusion of a multi step process

PANELS = ['#sector', '#amount', '#purposes', '#business']
PANEL_SELECTOR = '.panel-credit'
PANEL_VISIBLE_CLASS = 'panel-credit--visible'

showError = ($field, valid) ->
  $wrapper = $field.closest('.input')
  $wrapper.toggleClass('has-error', !valid)
  $error = $wrapper.find('span.error')
  if valid
    $error.remove() if $error.length > 0
  else
    errorMessage = $wrapper.data('validation-error')
    $wrapper.append($('<span class="error">' + errorMessage + '</span>')) if $error.length == 0 && errorMessage
  valid


isValid = ($panel) ->
  # FIXME hardcoded dependency from simple_form selectors
  return switch $panel.attr('id')
    when 'sector'
      !!$('#credit_sme_form_sector').val()
    when 'amount'
      $field = $('#credit_sme_form_amount')
      showError($field, $CAM.parseCurrency($field.val()) >= 20000)
    when 'purposes'
      $panel.find('input:checked').length > 0
    else
      false

togglePanel = ($panel, $el) ->
  $panel.toggleClass PANEL_VISIBLE_CLASS
  $($el.attr('href')).toggleClass PANEL_VISIBLE_CLASS

togglePanelFromHash = ->
  hash = window.location.hash
  if PANELS.indexOf(hash) != -1
    $panel = $(hash)
    $(PANEL_SELECTOR).removeClass PANEL_VISIBLE_CLASS
    $panel.addClass PANEL_VISIBLE_CLASS

$(document).on 'click', '[data-behaviour=panel-toggler]', (ev) ->
  $el = $ @
  $panel = $el.closest(PANEL_SELECTOR)
  if validate = Boolean $el.data('validate')
    if isValid($panel) then togglePanel($panel, $el) else false
  else
    togglePanel($panel, $el)

$(document).ready togglePanelFromHash
